// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding, SmSpacing } from '@alto/design-system';
import React from 'react';

type Props = {
  description?: string | null;
  details?: string | null;
};

export const CouponDetailsActionSheet = ({ description, details }: Props) => {
  return (
    <ActionSheetV2 title="How it works">
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        {description ? (
          <>
            <Body fontFamily="bold">{description}</Body>
            <SmSpacing />
          </>
        ) : null}
        {details ? <Body>{details}</Body> : null}
      </LgPadding>
    </ActionSheetV2>
  );
};
